import hitchApi from '../hitchEndPointBase';
import axios from 'axios';
import { useSelector } from 'react-redux';

const baseUrl = `${hitchApi}/auth/admin/`;

const login = (email, password) => axios.post(`${baseUrl}login`, { email, password });

const useHasPermission = (permission) => {
  permission = permission.toUpperCase();

  // Optional: `decodedToken` is null when signed out and on logout. PrivateRoute calls
  // this on every route match, including the one that redirects to /login, so a
  // non-optional read here crashes the app instead of bouncing to the login form.
  // Falling through to false is the right default for a permission check.
  const decodedToken = useSelector(state => state.auth.decodedToken);
  const permissions = decodedToken?.permissions;

  return Boolean(permissions?.includes(permission) || permissions?.includes(`ADMIN`));
};

export { login, useHasPermission };
